import Choices from "Choices.js"

export class WhereToDump
{
    wasteSearchSelect = document.querySelector('[data-s~="WasteSearch:select"]');
    wasteSearchRand = document.querySelector('[data-s~="WasteSearch:rand"]');
    wasteSearchToken = document.querySelector('[data-s~="WasteSearch:token"]');
    wasteSearchResults = document.querySelector('[data-s~="WasteSearch:results"]');
    wasteSearchResultsWaste = document.querySelector('[data-s~="WasteSearch:results:waste"]');
    wasteSearchResultsWasteBin = document.querySelector('[data-s~="WasteSearch:results:wasteBin"]');
    wasteSearchResultsWasteBinImg = document.querySelector('[data-s~="WasteSearch:results:wasteBinImg"]');
    wasteSearchResultsAdditionalPlace = document.querySelector('[data-s~="WasteSearch:results:additionalPlace"]');
    wasteSearchResultsAdditionalPlaceImg = document.querySelector('[data-s~="WasteSearch:results:additionalPlaceImg"]');
    wasteSearchResultsText = document.querySelector('[data-s~="WasteSearch:results:text"]');

    constructor(store)
    {
        this.store = store;
        this.txt = this.store.data.service.WhereToDump.txt;
    }

    prepareDataToSend(dataToCode)
    {
        let dataPart = [];
        for (let key in dataToCode) {
            dataPart.push(encodeURIComponent(key) + "=" + encodeURIComponent(dataToCode[key]));
        }
        return dataPart.join("&").replace(/%20/g, "+");
    }

    communicateWithBackend(wasteId)
    {
        const data = {
            rand: this.wasteSearchRand.value,
            token: this.wasteSearchToken.value,
            wasteId: wasteId
//            contactForm_recaptcha_verification: this.cfRecaptcha.value
        };
        const dataToSend = this.prepareDataToSend(data);

        return fetch('/ajax/where_to_dump.php', {
            method: 'POST',
//            mode: 'cors',
            cache: 'no-cache',
//            credentials: 'same-origin',
            headers: {
//                'Content-Type': 'application/json'
                'Content-Type': 'application/x-www-form-urlencoded'
            },
//            redirect: 'follow',
            referrerPolicy: 'no-referrer',
            body: dataToSend
        }).then(response => {
            return response.json();
        });
    }

    hideResultsContainer()
    {
        let dataD = this.wasteSearchResults.dataset.d;
        if (!dataD.search('dy=ne')) {
            dataD += ' dy=ne';
            this.wasteSearchResults.dataset.d = dataD;
        }
    }

    showResultsContainer()
    {
        let dataD = this.wasteSearchResults.dataset.d;
        dataD = dataD.replace('dy=ne', '');
        this.wasteSearchResults.dataset.d = dataD;
    }

    createImgTag(src, alt)
    {
        if (src) {
            const el = document.createElement('img');
            el.setAttribute('src', src);
            el.setAttribute('alt', alt);
            el.setAttribute('loading', 'lazy');
            el.dataset.d = 'wh=100px ht=100px ot-ft=cr';

            return el;
        } else {
            return null;
        }
    }

    removeImgTag(parent)
    {
        parent.querySelectorAll(':scope img').forEach((e) => {
            e.remove();
        });
    }

    fillInResultContainer(waste, wasteBin, wasteBinImg, additionalPlace, additionalPlaceImg, text)
    {
        this.wasteSearchResultsWaste.innerText = waste;
        this.wasteSearchResultsWasteBin.innerText = wasteBin;
        this.wasteSearchResultsAdditionalPlace.innerText = additionalPlace;
        this.wasteSearchResultsText.innerHTML = text;

        const wasteBinImgObj = this.createImgTag(wasteBinImg, this.txt[5] + ': ' + wasteBin);
        this.removeImgTag(this.wasteSearchResultsWasteBinImg);
        if (wasteBinImgObj) {
            this.wasteSearchResultsWasteBinImg.appendChild(wasteBinImgObj, additionalPlace);
        }

        const additionalPlaceImgObj = this.createImgTag(additionalPlaceImg, this.txt[6] + ': ' + additionalPlace);
        this.removeImgTag(this.wasteSearchResultsAdditionalPlaceImg);
        if (additionalPlaceImgObj) {
            this.wasteSearchResultsAdditionalPlaceImg.appendChild(additionalPlaceImgObj);
        }
    }

    getWasteData(wasteId)
    {
        this.communicateWithBackend(wasteId).then(response => {
            if (response !== 'token_error') { // && response !== 'recaptcha_error'
                this.hideResultsContainer();
                this.fillInResultContainer(response.waste, response.wasteBin, response.wasteBinImg, response.additionalPlace, response.additionalPlaceImg, response.text);
                this.showResultsContainer();
            }
        });
    }

    handle()
    {
        const streets = new Choices(this.wasteSearchSelect, {
            searchPlaceholderValue: this.txt[4],
            noResultsText: this.txt[1],
            labelId: 'wasteSearchLabel',
            searchFloor: 2,
            itemSelectText: this.txt[2],
            placeholderValue: this.txt[3],
            position: 'bottom'
        });

        this.wasteSearchSelect.addEventListener('choice', (e) => {
            let wasteId = e.detail.choice.value;
            this.getWasteData(wasteId);
        });

        //Odczytanie frazy wpisanej do wyszukiwarki
        //document.querySelector("[name=search_terms]").value
    }

    run()
    {
        document.addEventListener('DOMContentLoaded', () => {
            this.wasteSearchSelect && this.handle();
        });
    }
}